// Dependencies
import React from 'react';

// Utils
import { Stack } from '@nerdwallet/currency';

import {
  PropertyTaxRateInputWithAnalytics,
  HOADuesInputWithAnalytics,
  HomeInsuranceInputWithAnalytics,
  MaintainanceFeeInputWithAnalytics,
  RenovationFeesInputWithAnalytics,
  IncomeTaxRateInputWithAnalytics,
  RentersInsuranceInputWithAnalytics,
  BuyingCostsInputWithAnalytics,
  SellingCostsInputWithAnalytics,
  RentSecurityDepositInputWithAnalytics,
  HomeAppreciationInputWithAnalytics,
  RentAppreciationInputWithAnalytics,
  GeneralInflationInputWithAnalytics,
  AnnualReturnCashInputWithAnalytics,
  IncomeInputWithAnalytics,
  TaxFilingStatusInputWithAnalytics,
  CapitalGainsTaxRateInputWithAnalytics,
} from './inputs';
import { INPUT_CONTENT } from './shared/content';

import styles from './control-panel.module.less';

const SecondPanel = (): JSX.Element => {
  return (
    <Stack>
      <PropertyTaxRateInputWithAnalytics
        label={INPUT_CONTENT.PROPERTY_TAX_RATE.label}
        tooltip={INPUT_CONTENT.PROPERTY_TAX_RATE.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <HOADuesInputWithAnalytics
        label={INPUT_CONTENT.HOA_DUES.label}
        tooltip={INPUT_CONTENT.HOA_DUES.tooltip}
        fullWidth
      />
      <HomeInsuranceInputWithAnalytics
        label={INPUT_CONTENT.HOME_INSURANCE.label}
        tooltip={INPUT_CONTENT.HOME_INSURANCE.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <MaintainanceFeeInputWithAnalytics
        label={INPUT_CONTENT.MAINTAINANCE_FEE.label}
        tooltip={INPUT_CONTENT.MAINTAINANCE_FEE.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <RenovationFeesInputWithAnalytics
        label={INPUT_CONTENT.RENOVATION_FEES.label}
        tooltip={INPUT_CONTENT.RENOVATION_FEES.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <IncomeTaxRateInputWithAnalytics
        label={INPUT_CONTENT.INCOME_TAX_RATE.label}
        tooltip={INPUT_CONTENT.INCOME_TAX_RATE.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <RentersInsuranceInputWithAnalytics
        label={INPUT_CONTENT.RENTERS_INSURANCE.label}
        tooltip={INPUT_CONTENT.RENTERS_INSURANCE.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <BuyingCostsInputWithAnalytics
        label={INPUT_CONTENT.BUYING_COSTS.label}
        tooltip={INPUT_CONTENT.BUYING_COSTS.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <SellingCostsInputWithAnalytics
        label={INPUT_CONTENT.SELLING_COSTS.label}
        tooltip={INPUT_CONTENT.SELLING_COSTS.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <RentSecurityDepositInputWithAnalytics
        label={INPUT_CONTENT.RENT_SECURITY_DEPOSIT.label}
        tooltip={INPUT_CONTENT.RENT_SECURITY_DEPOSIT.tooltip}
        className={styles.numStepperWrapper}
        fullWidth
      />
      <HomeAppreciationInputWithAnalytics
        label={INPUT_CONTENT.HOME_APPRECIATION.label}
        tooltip={INPUT_CONTENT.HOME_APPRECIATION.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <RentAppreciationInputWithAnalytics
        label={INPUT_CONTENT.RENT_APPRECIATION.label}
        tooltip={INPUT_CONTENT.RENT_APPRECIATION.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <GeneralInflationInputWithAnalytics
        label={INPUT_CONTENT.GENERAL_INFLATION.label}
        tooltip={INPUT_CONTENT.GENERAL_INFLATION.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <AnnualReturnCashInputWithAnalytics
        label={INPUT_CONTENT.ANNUAL_RETURN_CASH.label}
        tooltip={INPUT_CONTENT.ANNUAL_RETURN_CASH.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <TaxFilingStatusInputWithAnalytics
        label={INPUT_CONTENT.TAX_FILING_STATUS.label}
        tooltip={INPUT_CONTENT.TAX_FILING_STATUS.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <IncomeInputWithAnalytics
        label={INPUT_CONTENT.INCOME.label}
        tooltip={INPUT_CONTENT.INCOME.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
      <CapitalGainsTaxRateInputWithAnalytics
        label={INPUT_CONTENT.CAPITAL_GAINS_TAX_RATE.label}
        tooltip={INPUT_CONTENT.CAPITAL_GAINS_TAX_RATE.tooltip}
        className={styles.inputPercentWidth}
        fullWidth
      />
    </Stack>
  );
};
export default SecondPanel;
